import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Grid, FormHelperText, Button } from '@material-ui/core';
import NumberFormat from 'react-number-format';
import Select from 'react-select';
import * as styles from './stepperStyle';
import { CompletedContext } from './StepperComponent';
import { validate } from '../../../utils/validateInputs';
import _ from 'lodash';
import {
  getBankByIBAN,
  clearBankByIBAN,
  saveBank,
  apllicantData
} from '../../../redux/actions/applicantAction';

function formatedIBAN(val) {
  // console.log( navigator.onLine);
  return 'UA' + val;
}

const useCompleted = () => {
  const contextValue = React.useContext(CompletedContext);
  return contextValue;
};

const BankAcount = props => {
  const { applicant, directories } = props;
  const [completed, dispatch] = useCompleted();

  const [submitted, setSubmitted] = React.useState(false);
  const handleChange = React.useCallback(
    _.debounce(q => props.handleApplicantChange(q), 500),
    []
  );

  const handleInputChange = e => {
    const { target } = e;
    handleChange(target);
  };

  const handleSelectChange = React.useCallback(
    name => select => {
      props.handleSelectApplicantChange(name, select);
    },
    []
  );

  // const handleCollbackBank = v => handleBank(v);

  const handleChangeBank = React.useCallback(
    _.debounce(q => props.handleBunkNumber('p_account', q), 500),
    []
  );

  const handleBank = values => {
    const { formattedValue } = values;
    // handleCollbackBank(formattedValue)
    // console.log(formattedValue);
    // this.props.handleAgreemant()
    handleChangeBank(formattedValue);
  };
  const handleSaveBank = () => {
    const data = {
      id: props.application.id,
      iban: applicant.p_account
    };
    const newCompleted = completed;
    props.saveBank(data)
    .then(resp => {
      newCompleted[props.activeStep] = true;
      // props.setCompleted(newCompleted);
      // props.handleNext();
      dispatch({ type: 'COMPLETED', payload: newCompleted });
      props.apllicantData(props.application.id);
      props.handleNext()
    })
    .catch(err => {
      newCompleted[props.activeStep] = false;
      // props.setCompleted(newCompleted);
      dispatch({ type: 'COMPLETED', payload: newCompleted });
    });
  };

  const valid = validate(applicant);

  React.useEffect(() => {
    // const newCompleted = props.completed;
    setSubmitted(true);
    // const newCompleted = completed;

    if (
      //   completedDocs(props.applicant)
      !!valid.p_account
    ) {
      // newCompleted[props.activeStep] = true;
      // // props.setCompleted(newCompleted);
      // // props.handleNext();
      // dispatch({ type: 'COMPLETED', payload: newCompleted });
      props.getBankByIBAN(applicant.p_account);
      // console.log('true', newCompleted);
    } else {
      // const newCompleted = props.completed;
      // newCompleted[props.activeStep] = false;
      // // props.setCompleted(newCompleted);
      // dispatch({ type: 'COMPLETED', payload: newCompleted });
      props.clearBankByIBAN();
      // console.log('false', newCompleted);
    }
    // console.log(previousCompleted.current , props.completed[0]);
    // if (previousCompleted.current !== props.completed[0]) {
    //     props.setCompleted(newCompleted);
    //     previousCompleted.current = props.completed[0];
    // }
  }, [applicant.p_account]);

  return (
    <div className="marginForStatementBlock">
      <Grid direction="row" container spacing={2}>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <div className="form-item">
            <label htmlFor="account">Рахунок для перерахування коштів </label>{' '}
            <NumberFormat
              value={applicant.p_account}
              // thousandSeparator={true}
              name="p_account"
              prefix={'UA'}
              placeholder="UA"
              maxLength="29"
              format={formatedIBAN}
              // decimalScale={2}
              onValueChange={handleBank}
            />
            {!(submitted && !applicant.p_account) && !valid.p_account && (
              <FormHelperText error id="name-error-text">
                {' '}
                Не валідне значення поля
              </FormHelperText>
            )}{' '}
            {submitted && !applicant.p_account && (
              <FormHelperText error id="name-error-text">
                {' '}
                Поле обов 'язкове
              </FormHelperText>
            )}{' '}
          </div>{' '}
        </Grid>{' '}
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <div className="form-item">
            <label htmlFor="bank">Назва банківської установи </label>{' '}
            <input
              // className={submitted && !applicant.p_mfo && 'error'}
              name="p_mfo"
              type="text"
              value={applicant.p_name || ''}
              onChange={handleInputChange}
              disabled
            />
            {/* <div className="selectWrapper">
              <Select
                //value={applicant.i_submittertype}
                // value={directories.banks.filter(
                //   ({ value }) => value === parseInt(applicant.p_mfo)
                // )}
                className={submitted && !applicant.p_mfo && 'error'}
                onChange={handleSelectChange('p_id')}
                name="i_submittertype"
                options={directories.banks}
                styles={styles.customStyles}
                placeholder=""
                // isLoading={props.isFatching.SET_CITY_FACT}
                noOptionsMessage={() => 'помилка серверу'}
                menuPortalTarget={document.body}
                theme={styles.customTheme}
              />{' '}
              {submitted && !applicant.p_mfo && (
                <FormHelperText error id="name-error-text">
                  {' '}
                  Поле обов 'язкове
                </FormHelperText>
              )}{' '}
            </div> */}
          </div>{' '}
        </Grid>{' '}
        <Grid item xs={12} sm={6} md={2} lg={3}>
          <div className="form-item">
            <label htmlFor="account">МФО </label>{' '}
            <input
              // className={submitted && !applicant.p_mfo && 'error'}
              name="p_mfo"
              type="text"
              value={applicant.p_mfo || ''}
              onChange={handleInputChange}
              disabled
            />
            {/* {submitted && !applicant.p_mfo && (
              <FormHelperText error id="name-error-text">
                {' '}
                Поле обов 'язкове
              </FormHelperText>
            )}{' '} */}
          </div>{' '}
        </Grid>{' '}
        <Grid item xs={12} sm={6} md={2} lg={3}>
          <div className="form-item">
            <label htmlFor="account">ЄДРПОУ </label>{' '}
            <input
              // className={submitted && !applicant.p_edrpou && 'error'}
              name="p_edrpou"
              type="text"
              value={applicant.p_edrpou || ''}
              onChange={handleInputChange}
              disabled
            />
            {/* {submitted && !applicant.p_edrpou && (
              <FormHelperText error id="name-error-text">
                {' '}
                Поле обов 'язкове
              </FormHelperText>
            )}{' '} */}
          </div>{' '}
        </Grid>{' '}
        <Grid direction="row" container spacing={2}>
          <Grid item xs={12}>
            {/* <Button
              disabled={props.activeStep === 0}
              onClick={props.handleBack}
              className="mr-2"
            >
              Назад
            </Button> */}
            {/* <Button
              variant="contained"
              color="primary"
              onClick={props.handleNext}
              className="mr-2"
            >
              Наступна
            </Button> */}
            <Button
              variant="contained"
              color="secondary"
              // onClick={props.handleNext}
              onClick={handleSaveBank}
            >
              {/* Next */}
              Зберегти
            </Button>
            {/* {props.activeStep !== props.steps.length &&
                (props.completed[props.activeStep] ? (
                  <Typography variant="caption">
                    Step {props.activeStep + 1} already completed
                  </Typography>
                ) : ( */}
            {/* <Button variant="contained" color="primary" onClick={handleComplete}> */}
            {/* {props.completedSteps() === props.totalSteps() - 1
                      ? 'Finish' */}
            {/* :  */}
            {/* Complete Step */}
            {/* '} */}
            {/* </Button> */}
            {/* ))} */}
          </Grid>
        </Grid>
      </Grid>{' '}
    </div>
  );
};


const mapStateToProps = state => ({
  applicant: state.applicant,
  directories: state.directories,
  application: state.application,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, {
  getBankByIBAN,
  clearBankByIBAN,
  saveBank,
  apllicantData
})(BankAcount);
